import { createConfigurable } from '@peloton/config-singleton';

export const { config, updateConfig } = createConfigurable<{
  streamSource: 'primary' | 'multichannel';
}>({
  streamSource: 'multichannel',
});
